import { slugify } from '@/utils/string';

export function buildCouponCodePreview(description: string): string {
  const normalized = slugify(description).replace(/-/g, '').toUpperCase();
  if (!normalized) return '';

  const prefix = normalized.slice(0, 6).padEnd(4, 'X');

  let hash = 0;
  for (const char of normalized) {
    hash = (hash * 31 + char.charCodeAt(0)) % 1679616;
  }

  const suffix = hash.toString(36).toUpperCase().padStart(4, '0').slice(-4);
  return `${prefix}${suffix}`;
}
